import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import VisionBanner from "../../../images/visionbanner.png";
import VisionBanner from '../../../images/Inner Page/Partner-Corner-Website-Banner.jpg'
function PartnersBanner() {
  return (
    <>
     <section className="banner-sc download-banner" aria-label="Partners Corner Banner">
        {/* <section className="home-banner-main">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="banner-content">
                  <h1>Partners  Corner</h1>
                  <p>
                   
                  </p>
                  
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}

        {/* <section className="banner-slider">
          <div className="home-banner-sc">
            <img
              src={VisionBanner}
              alt="Partner Corner Banner"
              className="img-fluid"
            />
          </div>

            <div className="banner-text-overlay">
        <div className="banner-content">
          <h1 className="banner-title">Your Main Heading Here</h1>
          <p className="banner-subtitle">
            Your subheading or description text goes here. 
            Make it attractive and compelling.
          </p>
          <button className="banner-btn">Learn More</button>
        </div>
      </div>

        </section> */}

        <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={VisionBanner}
                  alt=""
                  aria-hidden="true"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">Partners Corner</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
    
    </>
  )
}

export default PartnersBanner
